export default () => {
	setTimeout(function(){
		let input = document.querySelector('.search__input');
		if (input) {
			input.setAttribute('name', 'q')
		}
	}, 1000);
};